import { render, staticRenderFns } from "./CopyrightTaskQueue.vue?vue&type=template&id=4d50c232&scoped=true&"
import script from "./CopyrightTaskQueue.vue?vue&type=script&lang=js&"
export * from "./CopyrightTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightTaskQueue.vue?vue&type=style&index=0&id=4d50c232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50c232",
  null
  
)

export default component.exports